import { fas } from "@fortawesome/free-solid-svg-icons";
import { uniq } from "lodash";
import { PrimeIcons } from "primereact/api";
import { library } from "@fortawesome/fontawesome-svg-core";
import { IconType } from "./types";

export const FontAwesomeIcons = [...uniq(Object.values(fas))];

library.add(...FontAwesomeIcons);

export const PrimeReactIcons: string[] = [
  "pi pi-sort-alt-slash",
  "pi pi-sort-alpha-down-alt",
  "pi pi-sort-alpha-up-alt",
  "pi pi-sort-numeric-down-alt",
  "pi pi-sort-numeric-up-alt",
  ...uniq(Object.values(PrimeIcons)),
];

export const getIconType = (iconName?: string) => {
  return iconName?.startsWith("pi ")
    ? IconType.PrimeIcon
    : IconType.FontAwesome;
};
